import React from "react";
import AnimatorAtKioskScreen from "../../AnimatorAtKiosk";

const Screen21 = () => {
    return <AnimatorAtKioskScreen />;
};

export default Screen21;
